import { DataTable } from "@/components/data-table";
import { docsColumns } from "@/features/docs/components/docs-columns";
import { useTranslation } from "react-i18next";
import EmptyTable from "@/components/empty-table";
import { useDocumentationsList } from "@/features/docs/hooks/useDocumentationsList";
import ListContent from "@/features/docs/components/list-content";
import SearchInput from "@/components/search-input";
import { useDocsFilterStore } from "@/features/docs/stores";
import { useEffect } from "react";
import DocsTopicFilter from "@/features/docs/components/docs-topic-filter";

const DocumentationPage = () => {
  const { t } = useTranslation();
  const { documentations, page, pageCount, setPage, isLoading, isFetching } =
    useDocumentationsList();
  const { searchValue, setSearchValue, setTopicId } = useDocsFilterStore();

  useEffect(() => {
    return () => {
      setSearchValue(null);
      setTopicId(null);
    };
  }, [setSearchValue, setTopicId]);

  return (
    <div className="flex flex-col gap-y-3 pt-3 sm:pt-6 pb-24 relative">
      <div className="flex items-center gap-2 lg:hidden px-3 sm:px-6">
        <SearchInput
          value={searchValue ?? ""}
          onChange={setSearchValue}
          placeholder={t("modules.docs.keys.search_placeholder")}
        />
        <DocsTopicFilter />
      </div>
      <div className="hidden md:block overflow-x-scroll px-3 sm:px-6">
        <DataTable
          columns={docsColumns(t)}
          data={documentations}
          page={page}
          pageCount={pageCount}
          onPageChange={setPage}
          isLoading={isLoading || isFetching}
          emptyListComponent={<EmptyTableComponent />}
        />
      </div>
      <ListContent
        data={documentations}
        isLoading={isLoading || isFetching}
        page={page}
        pageCount={pageCount}
        onPageChange={setPage}
        className="md:hidden"
        emptyListComponent={<EmptyTableComponent />}
      />
    </div>
  );
};

const EmptyTableComponent = () => {
  const { t } = useTranslation();
  return <EmptyTable title={t("modules.docs.datatable.no_items")} />;
};

export default DocumentationPage;
